import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

import { blackberry, coolGrey, grape, greyStroke, squidInk, white } from 'lib/css/colors';
import { ManufacturerVerificationStatusOptions } from 'lib/enums/ManufacturerVerificationStatus';
import { selectStyles } from 'lib/css/selectStyles';

function ManufacturerFilters({
  setProductList,
  status,
  setStatus,
  loading,
  productList,
  setShowFilters,
  product_lists,
  productListOptions,
}) {
  const [selectedStatus, setSelectedStatus] = useState(status || '');
  const [selectedProductList, setSelectedProductList] = useState(
    productListOptions.find(option => option.label === productList?.name),
  );

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.header)}>
        <h4 className={css(styles.title)}>Filters</h4>
        <Button
          variant="link"
          className={css(styles.closeButton)}
          onClick={() => setShowFilters(false)}
          aria-label="Close filters"
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </div>
      <div className={css(styles.divider)} />
      <div className={css(styles.filtersBody)}>
        <Form.Group className={css(styles.formGroup)}>
          <Form.Label className={css(styles.label)}>Product List</Form.Label>
          <Select
            isClearable
            options={productListOptions}
            value={selectedProductList}
            placeholder="Select a Product List"
            onChange={setSelectedProductList}
            styles={selectStyles}
          />
        </Form.Group>
        <Form.Group className={css(styles.formGroup)}>
          <Form.Label className={css(styles.label)}>Status</Form.Label>
          <Select
            isClearable
            options={ManufacturerVerificationStatusOptions}
            value={ManufacturerVerificationStatusOptions.find(
              statu => statu?.value === selectedStatus,
            )}
            placeholder="Select Manufacturer Verification Status"
            onChange={option => setSelectedStatus(option?.value)}
            styles={selectStyles}
          />
        </Form.Group>
      </div>
      <div className={css(styles.footer)}>
        <Button
          className={css(styles.applyButton)}
          disabled={loading}
          onClick={() => {
            setProductList(product_lists.find(list => list.id === selectedProductList?.value));
            setStatus(selectedStatus);
            setShowFilters(false);
          }}
        >
          Apply Filters
        </Button>
        <Button
          className={css(styles.clearButton)}
          variant="outline-secondary"
          onClick={() => {
            setSelectedProductList(null);
            setSelectedStatus('');
            setProductList(undefined);
            setStatus('');
          }}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '90vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: squidInk,
    margin: 0,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: coolGrey,
    fontSize: 18,
    cursor: 'pointer',
    padding: 8,
    borderRadius: 6,
    ':hover': {
      backgroundColor: `${grape}15`,
      color: grape,
    },
  },
  divider: {
    height: 1,
    backgroundColor: greyStroke,
    marginBottom: 20,
  },
  filtersBody: {
    flex: 1,
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: squidInk,
    marginBottom: 8,
  },
  footer: {
    display: 'flex',
    gap: 12,
    paddingTop: 20,
    borderTop: `1px solid ${greyStroke}`,
  },
  applyButton: {
    backgroundColor: blackberry,
    color: white,
    border: 'none',
    borderRadius: 8,
    padding: '10px 20px',
    fontWeight: 600,
    fontSize: 14,
    flex: 1,
    ':hover': {
      backgroundColor: grape,
    },
  },
  clearButton: {
    backgroundColor: 'transparent',
    color: coolGrey,
    border: `1px solid ${greyStroke}`,
    borderRadius: 8,
    padding: '10px 20px',
    fontWeight: 600,
    fontSize: 14,
    ':hover': {
      backgroundColor: `${coolGrey}10`,
      borderColor: coolGrey,
    },
  },
});

ManufacturerFilters.propTypes = {
  productList: PropTypes.object,
  setProductList: PropTypes.func,
  loading: PropTypes.bool,
  status: PropTypes.string,
  setStatus: PropTypes.func,
  setShowFilters: PropTypes.func,
  product_lists: PropTypes.array,
  productListOptions: PropTypes.array,
};

export default ManufacturerFilters;
